// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/booking/shared/provider_booking_details.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file proto/model/booking/shared/provider_booking_details.proto.
 */
export const file_proto_model_booking_shared_provider_booking_details = /*@__PURE__*/
  fileDesc("Cjlwcm90by9tb2RlbC9ib29raW5nL3NoYXJlZC9wcm92aWRlcl9ib29raW5nX2RldGFpbHMucHJvdG8SBmNhcm1lbiLFBAoWUHJvdmlkZXJCb29raW5nRGV0YWlscxIbChNjb25maXJtYXRpb25fbnVtYmVyGAEgASgJEhkKEWJvb2tpbmdfcmVmZXJlbmNlGAIgASgJEhcKD2Jvb2tpbmdfY2hhbm5lbBgDIAEoCRJHCg1wcm92aWRlcl9kYXRhGAQgAygLMjAuY2FybWVuLlByb3ZpZGVyQm9va2luZ0RldGFpbHMuUHJvdmlkZXJEYXRhRW50cnkSVQoUc2VydmljZV9pbnN0cnVjdGlvbnMYBSADKAsyNy5jYXJtZW4uUHJvdmlkZXJCb29raW5nRGV0YWlscy5TZXJ2aWNlSW5zdHJ1Y3Rpb25zRW50cnkSSAoQcHJvdmlkZXJfY29udGFjdBgGIAEoCzIuLmNhcm1lbi5Qcm92aWRlckJvb2tpbmdEZXRhaWxzLlByb3ZpZGVyQ29udGFjdBp/Cg9Qcm92aWRlckNvbnRhY3QSDAoEbmFtZRgBIAEoCRIVCg1waG9uZV9udW1iZXJzGAIgAygJEhcKD2VtYWlsX2FkZHJlc3NlcxgDIAMoCRITCgt3ZWJzaXRlX3VybBgEIAEoCRIZChFlbWVyZ2VuY3lfY29udGFjdBgFIAEoCRozChFQcm92aWRlckRhdGFFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBGjoKGFNlcnZpY2VJbnN0cnVjdGlvbnNFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBQjBaLmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2Jvb2tpbmdiBnByb3RvMw");

/**
 * Describes the message carmen.ProviderBookingDetails.
 * Use `create(ProviderBookingDetailsSchema)` to create a new message.
 */
export const ProviderBookingDetailsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_shared_provider_booking_details, 0);

/**
 * Describes the message carmen.ProviderBookingDetails.ProviderContact.
 * Use `create(ProviderBookingDetails_ProviderContactSchema)` to create a new message.
 */
export const ProviderBookingDetails_ProviderContactSchema = /*@__PURE__*/
  messageDesc(file_proto_model_booking_shared_provider_booking_details, 0, 0);

